var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticStyle: { display: "inline" } },
    [
      _c(
        "el-select",
        {
          attrs: { placeholder: "Категория", "value-key": "id" },
          on: { change: _vm.selectCategory },
          model: {
            value: _vm.selectedCategory,
            callback: function ($$v) {
              _vm.selectedCategory = $$v
            },
            expression: "selectedCategory",
          },
        },
        _vm._l(_vm.categories, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.name, value: item },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-button-group",
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-edit" },
              on: {
                click: function ($event) {
                  _vm.categoryEditForm = Object.assign({}, _vm.selectedCategory)
                  _vm.categoryEditFormVisible = true
                },
              },
            },
            [_vm._v("Редактировать")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger", icon: "el-icon-delete" },
              on: {
                click: function ($event) {
                  return _vm.categoryDelete(_vm.selectedCategory)
                },
              },
            },
            [_vm._v("Удалить")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          attrs: { size: "small" },
          on: {
            click: function ($event) {
              _vm.categoryAddForm = { id: null, name: "" }
              _vm.categoryAddFormVisible = true
            },
          },
        },
        [_vm._v("Добавить категорию")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Редактирование категории",
            visible: _vm.categoryEditFormVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.categoryEditFormVisible = $event
            },
            close: function ($event) {
              _vm.categoryEditForm = { id: null, name: "" }
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "categoryEditForm",
              attrs: {
                model: _vm.categoryEditForm,
                "label-position": "right",
                "label-width": "15%",
                rules: _vm.categoryRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Название", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.categoryEditForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.categoryEditForm, "name", $$v)
                      },
                      expression: "categoryEditForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitCategoryEditForm },
                    },
                    [_vm._v("Готово")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Добавление категории",
            visible: _vm.categoryAddFormVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.categoryAddFormVisible = $event
            },
            close: function ($event) {
              _vm.categoryAddForm = { id: null, name: "" }
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "categoryAddForm",
              attrs: {
                model: _vm.categoryAddForm,
                "label-position": "right",
                "label-width": "15%",
                rules: _vm.categoryRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Название", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.categoryAddForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.categoryAddForm, "name", $$v)
                      },
                      expression: "categoryAddForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitCategoryAddForm },
                    },
                    [_vm._v("Готово")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }